import React from 'react';
import { FixedSizeList as List, ListChildComponentProps } from 'react-window';
import { lightGray } from '../../../utils/style/colors';
import { ICompanyMember } from 'store/companies/companiesTypes';
import { languageDirection } from '../../../i18n';

interface IComponentProps {
  height: number;
  memberItems: (childProps: ListChildComponentProps) => JSX.Element;
  filteredCompanyMembers: ICompanyMember[];
}

const CompanyMembersList: React.FC<IComponentProps> = ({
  height,
  memberItems,
  filteredCompanyMembers,
}) => {
  return (
    <List
      width="100"
      height={height - 160} // space from bottom
      itemData={{ filteredCompanyMembers }}
      itemSize={40}
      itemCount={filteredCompanyMembers.length}
      direction={languageDirection()}
      style={{
        borderRadius: '15px',
        border: `1px solid ${lightGray}`,
        overflow: 'overlay',
      }}
    >
      {memberItems}
    </List>
  );
};

export default CompanyMembersList; // memo(CompanyMembersList);
